//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';

interface IOwnProps {
  /**
   * Whether or not the wrapper should be applied
   */
  shouldWrap: boolean;
  /**
   * A render function that should return {children} wrapped by some elements.
   */
  renderWrap: (children: React.ReactNode) => React.ReactElement | null;
}

/**
 * Conditionally wrap the children of this component with some other DOM tree.
 */
const ConditionalWrapper: React.FunctionComponent<IOwnProps> = ({
  shouldWrap,
  renderWrap,
  children,
}) => shouldWrap ? renderWrap(children) : <>{ children }</>;

export default ConditionalWrapper;
